import Paper from "@material-ui/core/Paper";
import { AccessTime, Badge as BadgeIcon, Language, StarBorder } from '@mui/icons-material';
import { useMediaQuery } from "@mui/material";
import { AxiosError } from "axios";
import React from "react";

import createFormIcon from '../assets/createFormIcon.svg';
import createUsingAIIcon from '../assets/createUsingAIIcon.svg';
import { ReactComponent as CurrencyIcon } from '../assets/currencyIcon.svg';
import multiImageSelectIcon from '../assets/multiImageSelectIcon.svg';
import noteIcon from '../assets/noteIcon.svg';
import pictureSelectIcon from '../assets/pictureSelectIcon.svg';
import selectFromTemplateIcon from '../assets/selectFromTemplateIcon.svg';
import TimezoneIcon from '../assets/TimezoneIcon.png';

import {
  AppointmentIcon,
  CalculativeIcon,
  DateAndTimeIcon,
  DateIcon,
  DomainIcon,
  DropDownIcon,
  EmailIcon,
  FacebookIcon,
  GeolocationIcon,
  GoogleIcon,
  HtmlIcon,
  InputIcon,
  LinkedInIcon,
  MultiInputIcon,
  MultiSelectIcon,
  NameAndSurnameIcon,
  AddressIcon,
  OpenProjectIcon,
  PaymentIcon,
  PhoneIcon,
  RichTextIcon,
  SingleSelectIcon,
  TiktokIcon,
  TwitterIcon,
  CameraIcon,
  ContactInfoIcon
} from "./TypesIcons";

import { DefaultChoicesContainer, DefaultChoicesImageContainer, DefaultChoicesTextContainer } from "./styled";

import { globalColors } from "./colors";
import './style.scss';

export const dropdownMenu = [
  {
    label: "Single Select",
    value: "select",
    iconRenderer: () => <SingleSelectIcon />,
  },
  {
    label: "Multi Select",
    value: "multi-select",
    iconRenderer: () => <MultiSelectIcon />,
  },
  {
    label: "Input",
    value: "input",
    iconRenderer: () => <InputIcon />
  },
  {
    label: "Rich Text",
    value: "richText",
    iconRenderer: () => <RichTextIcon />
  },
  {
    label: "Name and Surname",
    value: "nameAndSurname",
    iconRenderer: () => <NameAndSurnameIcon />,
  },
  {
    label: "Contact Info",
    value: "contactInfo",
    iconRenderer: () => <ContactInfoIcon />,
  },
  {
    label: "Address",
    value: "address",
    iconRenderer: () => <AddressIcon />,
  },
  {
    label: "Rating",
    value: "rating",
    iconRenderer: () => <StarBorder style={{ color: globalColors.primary }} />,
  },
  {
    label: "Domain",
    value: "domain",
    iconRenderer: () => <DomainIcon />
  },
  {
    label: "Email",
    value: "email",
    iconRenderer: () => <EmailIcon />
  },
  {
    label: "Phone Number",
    value: "phoneNumber",
    iconRenderer: () => <PhoneIcon />,
  },
  {
    label: "Multi Input",
    value: "multi-input",
    iconRenderer: () => <MultiInputIcon />,
  },
  {
    label: "Image Selection",
    value: "image-select",
    iconRenderer: () => <img alt="" src={pictureSelectIcon} height={16} />,
  },
  {
    label: "Multi Image Selection",
    value: "image-multi-select",
    iconRenderer: () => <img alt="" src={multiImageSelectIcon} height={16} />,
  },
  {
    label: "Dropdown",
    value: "dropdown",
    iconRenderer: () => <DropDownIcon />,
  },
  {
    label: "Html",
    value: "html",
    iconRenderer: () => <HtmlIcon />
  },
  {
    label: "Calculation",
    value: "calculation",
    iconRenderer: () => <CalculativeIcon />
  },
  {
    label: 'Currency',
    value: 'currency',
    iconRenderer: () => <CurrencyIcon />
  },
  {
    label: 'Country',
    value: 'country',
    iconRenderer: () => <Language />
  },
  // {
  //   label: "Geolocation",
  //   value: "geolocation",
  //   iconRenderer: () => <GeolocationIcon />
  // },
  {
    label: "Payment",
    value: "payment",
    iconRenderer: () => <PaymentIcon />
  },
  {
    label: "Date",
    value: "date",
    iconRenderer: () => <DateIcon />
  },
  {
    label: "Date and Time",
    value: "dateAndTime",
    iconRenderer: () => <DateAndTimeIcon />,
  },
  {
    label: "Time",
    value: "time",
    iconRenderer: () => <AccessTime />,
  },
  {
    label: "Timezone",
    value: "timezone",
    iconRenderer: () => <img alt="" height={20} src={TimezoneIcon} />,
  },
  {
    label: "Appointment",
    value: "appointment",
    iconRenderer: () => <AppointmentIcon />,
  },
  {
    label: "Linked in",
    value: "linkedin",
    iconRenderer: () => <LinkedInIcon />
  },
  {
    label: "google",
    value: "google",
    iconRenderer: () => <GoogleIcon />
  },
  {
    label: "facebook",
    value: "facebook",
    iconRenderer: () => <FacebookIcon />
  },
  {
    label: "Twitter",
    value: "twitter",
    iconRenderer: () => <TwitterIcon />
  },
  {
    label: "Openproject",
    value: "openproject",
    iconRenderer: () => <OpenProjectIcon />
  },
  {
    label: "Tiktok",
    value: "tiktok",
    iconRenderer: () => <TiktokIcon />
  },
  {
    label: "Employee",
    value: "employee",
    iconRenderer: () => <BadgeIcon sx={{ color: "black" }} />
  },
  {
    label: "Capture",
    value: "capture",
    iconRenderer: () => <CameraIcon />
  },
];

export const systemFields = ['contactInfo', 'nameAndSurname', 'address', 'domain', 'email']

export const optionModeConstants = {
  advanced: "advanced",
  basic: "basic",
};

export const Currencymenu: any = [{ label: 'EUR', value: 'EUR' },
{ label: 'GBP', value: 'GBP' },
{ label: 'USD', value: 'USD' },
{ label: 'AUD', value: 'AUD' },
{ label: 'CAD', value: 'CAD' },
{ label: 'CHF', value: 'CHF' },
{ label: 'NOK', value: 'NOK' },
{ label: 'SEK', value: 'SEK' },
{ label: 'DKK', value: 'DKK' },
{ label: 'MXN', value: 'MXN' },
{ label: 'NZD', value: 'NZD' },
{ label: 'BRL', value: 'BRL' }
]
export const YesorNo: any = [
  { label: 'Yes', value: 'Yes', "score": "" },
  { label: 'No', value: 'No', "score": "" }
]
export const Application: any = [
  { label: 'Feedback', value: 'feedback' },
  { label: 'Research', value: 'research' },
  { label: 'Registration', value: 'registration' },
  { label: 'Capture', value: 'capture' },
  { label: 'Quiz', value: 'quiz' },
  { label: 'Application', value: 'application' },
  { label: 'Poll', value: 'poll' },
  { label: 'Order', value: 'order' },
  { label: 'Report', value: 'report' },
  { label: 'Request', value: 'request' },
  { label: 'Giveaway', value: 'giveaway' },
]
export const Department: any = [
  { label: 'HR', value: 'hr' },
  { label: 'Sales', value: 'sales' },
  { label: 'Procurement', value: 'procurement' },
  { label: 'Customer Success', value: 'customerSuccess' },
  { label: 'Marketing', value: 'marketing' },
  { label: 'Product', value: 'product' },
  { label: 'Finance', value: 'finance' },
  { label: 'Operation', value: 'operation' },
]
export const InputTypes: any = [
  { label: 'Text Area', value: 'textArea' },
  { label: 'URL', value: 'url' },
  { label: 'Email', value: 'email' },
  { label: 'Text', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Decimal', value: 'decimal' },
  { label: 'File', value: 'file' },
  { label: 'Scanner', value: 'scanner' },
  { label: 'Country', value: 'country' },
]

export const MultiInput: any = [
  { label: 'Text Area', value: 'textArea' },
  { label: 'URL', value: 'url' },
  { label: 'Email', value: 'email' },
  { label: 'Text', value: 'text' },
  { label: 'Number', value: 'number' },
  { label: 'Decimal', value: 'decimal' }
]

export const sortByOptions = [
  { label: "Name (A-Z)", value: "ascending" },
  { label: "Name (Z-A)", value: "descending" },
  { label: "Date (New - Old)", value: "newest" },
  { label: "Date (Old - New)", value: "oldest" },
];
export const sortByDate = [
  { label: "Created", value: "created" },
  { label: "Updated", value: "updated" },
];

export const filterByOptions = [
  { label: "Form Name", value: "formName" },
  { label: "Use Case", value: "UseCase" },
  { label: "Department", value: "Department" },
  { label: "Application", value: "Application" }
]

export const templateLibrary = [
  { label: "All Templates", value: 100, count: 0 },
  { label: "Advertising & Marketing", value: 29, count: 0 },
  { label: "Business & Services", value: 36, count: 0 },
  { label: "Ecommerce", value: 115, count: 0 },
  { label: "Education", value: 7, count: 0 },
  { label: "Events & Entertainment", value: 9, count: 0 },
  { label: "Featured Templates", value: 25, count: 0 },
  { label: "Health & Beauty", value: 5, count: 0 },
  { label: "Software & Technology", value: 4, count: 0 },
  { label: "Systemic", value: 11, count: 0 },
  { label: "Travel, Hotel & Restaurant", value: 8, count: 0 },
  { label: "sample", value: 0, count: 0 },
]

export const Position: any = [
  { label: 'TOP LEFT', value: 'top-left' },
  { label: 'TOP RIGHT', value: 'top-right' },
  { label: 'BOTTOM LEFT', value: 'bottom-left' },
  { label: 'BOTTOM RIGHT', value: 'bottom-right' }
]

export const sortOptions = [
  { label: "Last modified", value: "lastModified" },
  { label: "Name", value: "name" },
];

export const logicalOperations = [{ label: "<", value: "less_than" }, { label: "=", value: "equal_to" }, { label: ">", value: "greater_than" }]

export interface IResponse {
  data: any,
  status: string,
  statusCode: number,
  message: string
}

export const parseAxiosError = (error: AxiosError): IResponse => {
  const errorObject: any = error?.response?.data;
  return { status: errorObject.status, statusCode: errorObject.statusCode, message: errorObject.message, data: [] }
}

export const STATUS = {
  SUCCESS: 'success',
  ERROR: 'error'
}

export const Alphabets = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]

export const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const urlRegex = /^(https?:\/\/)?[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})(\/.*)?$/i

export const endpointRegex = /^https?:\/\/[a-zA-Z0-9\-._~:\/?#@!$&'()*+,;=%]+$/i

export const unregisterMethods = (methods: any, methodNames: any) => {
  methodNames.forEach((methodName: any) => {
    methods.unregister(methodName);
  });
}

export const fontFamilies = [
  { label: 'Arial', value: 'Arial' },
  { label: 'Arial Black', value: 'Arial Black' },
  { label: 'Comic Sans MS', value: 'Comic Sans MS' },
  { label: 'Courier New', value: 'Courier New' },
  { label: 'Georgia', value: 'Georgia' },
  { label: 'Helvetica', value: 'Helvetica' },
  { label: 'Manrope', value: 'Manrope' },
  { label: 'Poppins', value: 'Poppins' },
  { label: 'Times New Roman', value: 'Times New Roman' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS' },
  { label: 'Verdana', value: 'Verdana' },
]

export const countries = [
  { name: "Afghanistan", dial_code: "+93", code: "AF", flag: "🇦🇫" },
  { name: "Åland Islands", dial_code: "+358", code: "AX", flag: "🇦🇽" },
  { name: "Albania", dial_code: "+355", code: "AL", flag: "🇦🇱" },
  { name: "Algeria", dial_code: "+213", code: "DZ", flag: "🇩🇿" },
  {
    name: "American Samoa",
    dial_code: "+1684",
    code: "AS",
    flag: "🇦🇸",
  },
  { name: "Andorra", dial_code: "+376", code: "AD", flag: "🇦🇩" },
  { name: "Angola", dial_code: "+244", code: "AO", flag: "🇦🇴" },
  { name: "Anguilla", dial_code: "+1264", code: "AI", flag: "🇦🇮" },
  { name: "Antarctica", dial_code: "+672", code: "AQ", flag: "🇦🇶" },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
    flag: "🇦🇬",
  },
  { name: "Argentina", dial_code: "+54", code: "AR", flag: "🇦🇷" },
  { name: "Armenia", dial_code: "+374", code: "AM", flag: "🇦🇲" },
  { name: "Aruba", dial_code: "+297", code: "AW", flag: "🇦🇼" },
  { name: "Australia", dial_code: "+61", code: "AU", flag: "🇦🇺" },
  { name: "Austria", dial_code: "+43", code: "AT", flag: "🇦🇹" },
  { name: "Azerbaijan", dial_code: "+994", code: "AZ", flag: "🇦🇿" },
  { name: "Bahamas", dial_code: "+1242", code: "BS", flag: "🇧🇸" },
  { name: "Bahrain", dial_code: "+973", code: "BH", flag: "🇧🇭" },
  { name: "Bangladesh", dial_code: "+880", code: "BD", flag: "🇧🇩" },
  { name: "Barbados", dial_code: "+1246", code: "BB", flag: "🇧🇧" },
  { name: "Belarus", dial_code: "+375", code: "BY", flag: "🇧🇾" },
  { name: "Belgium", dial_code: "+32", code: "BE", flag: "🇧🇪" },
  { name: "Belize", dial_code: "+501", code: "BZ", flag: "🇧🇿" },
  { name: "Benin", dial_code: "+229", code: "BJ", flag: "🇧🇯" },
  { name: "Bermuda", dial_code: "+1441", code: "BM", flag: "🇧🇲" },
  { name: "Bhutan", dial_code: "+975", code: "BT", flag: "🇧🇹" },
  {
    name: "Bolivia, Plurinational State of bolivia",
    dial_code: "+591",
    code: "BO",
    flag: "🇧🇴",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
    flag: "🇧🇦",
  },
  { name: "Botswana", dial_code: "+267", code: "BW", flag: "🇧🇼" },
  { name: "Bouvet Island", dial_code: "+47", code: "BV", flag: "🏳" },
  { name: "Brazil", dial_code: "+55", code: "BR", flag: "🇧🇷" },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
    flag: "🇮🇴",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
    flag: "🇧🇳",
  },
  { name: "Bulgaria", dial_code: "+359", code: "BG", flag: "🇧🇬" },
  { name: "Burkina Faso", dial_code: "+226", code: "BF", flag: "🇧🇫" },
  { name: "Burundi", dial_code: "+257", code: "BI", flag: "🇧🇮" },
  { name: "Cambodia", dial_code: "+855", code: "KH", flag: "🇰🇭" },
  { name: "Cameroon", dial_code: "+237", code: "CM", flag: "🇨🇲" },
  { name: "Canada", dial_code: "+1", code: "CA", flag: "🇨🇦" },
  { name: "Cape Verde", dial_code: "+238", code: "CV", flag: "🇨🇻" },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
    flag: "🇰🇾",
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
    flag: "🇨🇫",
  },
  { name: "Chad", dial_code: "+235", code: "TD", flag: "🇹🇩" },
  { name: "Chile", dial_code: "+56", code: "CL", flag: "🇨🇱" },
  { name: "China", dial_code: "+86", code: "CN", flag: "🇨🇳" },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
    flag: "🇨🇽",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
    flag: "🇨🇨",
  },
  { name: "Colombia", dial_code: "+57", code: "CO", flag: "🇨🇴" },
  { name: "Comoros", dial_code: "+269", code: "KM", flag: "🇰🇲" },
  { name: "Congo", dial_code: "+242", code: "CG", flag: "🇨🇬" },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dial_code: "+243",
    code: "CD",
    flag: "🇨🇩",
  },
  { name: "Cook Islands", dial_code: "+682", code: "CK", flag: "🇨🇰" },
  { name: "Costa Rica", dial_code: "+506", code: "CR", flag: "🇨🇷" },
  { name: "Cote d'Ivoire", dial_code: "+225", code: "CI", flag: "🇨🇮" },
  { name: "Croatia", dial_code: "+385", code: "HR", flag: "🇭🇷" },
  { name: "Cuba", dial_code: "+53", code: "CU", flag: "🇨🇺" },
  { name: "Cyprus", dial_code: "+357", code: "CY", flag: "🇨🇾" },
  { name: "Czech Republic", dial_code: "+420", code: "CZ", flag: "🇨🇿" },
  { name: "Denmark", dial_code: "+45", code: "DK", flag: "🇩🇰" },
  { name: "Djibouti", dial_code: "+253", code: "DJ", flag: "🇩🇯" },
  { name: "Dominica", dial_code: "+1767", code: "DM", flag: "🇩🇲" },
  {
    name: "Dominican Republic",
    dial_code: "+1849",
    code: "DO",
    flag: "🇨🇩",
  },
  { name: "Ecuador", dial_code: "+593", code: "EC", flag: "🇪🇨" },
  { name: "Egypt", dial_code: "+20", code: "EG", flag: "🇪🇬" },
  { name: "El Salvador", dial_code: "+503", code: "SV", flag: "🇸🇻" },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
    flag: "🇬🇶",
  },
  { name: "Eritrea", dial_code: "+291", code: "ER", flag: "🇪🇷" },
  { name: "Estonia", dial_code: "+372", code: "EE", flag: "🇪🇪" },
  { name: "Ethiopia", dial_code: "+251", code: "ET", flag: "🇪🇹" },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
    flag: "🇫🇰",
  },
  { name: "Faroe Islands", dial_code: "+298", code: "FO", flag: "🇫🇴" },
  { name: "Fiji", dial_code: "+679", code: "FJ", flag: "🇫🇯" },
  { name: "Finland", dial_code: "+358", code: "FI", flag: "🇫🇮" },
  { name: "France", dial_code: "+33", code: "FR", flag: "🇫🇷" },
  { name: "French Guiana", dial_code: "+594", code: "GF", flag: "🇬🇫" },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
    flag: "🇵🇫",
  },
  {
    name: "French Southern Territories",
    dial_code: "+262",
    code: "TF",
    flag: "🇹🇫",
  },
  { name: "Gabon", dial_code: "+241", code: "GA", flag: "🇬🇦" },
  { name: "Gambia", dial_code: "+220", code: "GM", flag: "🇬🇲" },
  { name: "Georgia", dial_code: "+995", code: "GE", flag: "🇬🇪" },
  { name: "Germany", dial_code: "+49", code: "DE", flag: "🇩🇪" },
  { name: "Ghana", dial_code: "+233", code: "GH", flag: "🇬🇭" },
  { name: "Gibraltar", dial_code: "+350", code: "GI", flag: "🇬🇮" },
  { name: "Greece", dial_code: "+30", code: "GR", flag: "🇬🇷" },
  { name: "Greenland", dial_code: "+299", code: "GL", flag: "🇬🇱" },
  { name: "Grenada", dial_code: "+1473", code: "GD", flag: "🇬🇩" },
  { name: "Guadeloupe", dial_code: "+590", code: "GP", flag: "🇬🇵" },
  { name: "Guam", dial_code: "+1671", code: "GU", flag: "🇬🇺" },
  { name: "Guatemala", dial_code: "+502", code: "GT", flag: "🇬🇹" },
  { name: "Guernsey", dial_code: "+44", code: "GG", flag: "🇬🇬" },
  { name: "Guinea", dial_code: "+224", code: "GN", flag: "🇬🇳" },
  { name: "Guinea-Bissau", dial_code: "+245", code: "GW", flag: "🇬🇼" },
  { name: "Guyana", dial_code: "+592", code: "GY", flag: "🇬🇾" },
  { name: "Haiti", dial_code: "+509", code: "HT", flag: "🇭🇹" },
  {
    name: "Heard Island and Mcdonald Islands",
    dial_code: "+0",
    code: "HM",
    flag: "🏳",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
    flag: "🇻🇦",
  },
  { name: "Honduras", dial_code: "+504", code: "HN", flag: "🇭🇳" },
  { name: "Hong Kong", dial_code: "+852", code: "HK", flag: "🇭🇰" },
  { name: "Hungary", dial_code: "+36", code: "HU", flag: "🇭🇺" },
  { name: "Iceland", dial_code: "+354", code: "IS", flag: "🇮🇸" },
  { name: "India", dial_code: "+91", code: "IN", flag: "🇮🇳" },
  { name: "Indonesia", dial_code: "+62", code: "ID", flag: "🇮🇩" },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dial_code: "+98",
    code: "IR",
    flag: "🇮🇷",
  },
  { name: "Iraq", dial_code: "+964", code: "IQ", flag: "🇮🇶" },
  { name: "Ireland", dial_code: "+353", code: "IE", flag: "🇮🇪" },
  { name: "Isle of Man", dial_code: "+44", code: "IM", flag: "🇮🇲" },
  { name: "Israel", dial_code: "+972", code: "IL", flag: "🇮🇱" },
  { name: "Italy", dial_code: "+39", code: "IT", flag: "🇮🇹" },
  { name: "Jamaica", dial_code: "+1876", code: "JM", flag: "🇯🇲" },
  { name: "Japan", dial_code: "+81", code: "JP", flag: "🇯🇵" },
  { name: "Jersey", dial_code: "+44", code: "JE", flag: "🇯🇪" },
  { name: "Jordan", dial_code: "+962", code: "JO", flag: "🇯🇴" },
  { name: "Kazakhstan", dial_code: "+7", code: "KZ", flag: "🇰🇿" },
  { name: "Kenya", dial_code: "+254", code: "KE", flag: "🇰🇪" },
  { name: "Kiribati", dial_code: "+686", code: "KI", flag: "🇰🇮" },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: "+850",
    code: "KP",
    flag: "🇰🇵",
  },
  {
    name: "Korea, Republic of South Korea",
    dial_code: "+82",
    code: "KR",
    flag: "🇰🇷",
  },
  { name: "Kosovo", dial_code: "+383", code: "XK", flag: "🇽🇰" },
  { name: "Kuwait", dial_code: "+965", code: "KW", flag: "🇰🇼" },
  { name: "Kyrgyzstan", dial_code: "+996", code: "KG", flag: "🇰🇬" },
  { name: "Laos", dial_code: "+856", code: "LA", flag: "🇱🇦" },
  { name: "Latvia", dial_code: "+371", code: "LV", flag: "🇱🇻" },
  { name: "Lebanon", dial_code: "+961", code: "LB", flag: "🇱🇧" },
  { name: "Lesotho", dial_code: "+266", code: "LS", flag: "🇱🇸" },
  { name: "Liberia", dial_code: "+231", code: "LR", flag: "🇱🇷" },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
    flag: "🇱🇾",
  },
  { name: "Liechtenstein", dial_code: "+423", code: "LI", flag: "🇱🇮" },
  { name: "Lithuania", dial_code: "+370", code: "LT", flag: "🇱🇹" },
  { name: "Luxembourg", dial_code: "+352", code: "LU", flag: "🇱🇺" },
  { name: "Macao", dial_code: "+853", code: "MO", flag: "🇲🇴" },
  { name: "Macedonia", dial_code: "+389", code: "MK", flag: "🇲🇰" },
  { name: "Madagascar", dial_code: "+261", code: "MG", flag: "🇲🇬" },
  { name: "Malawi", dial_code: "+265", code: "MW", flag: "🇲🇼" },
  { name: "Malaysia", dial_code: "+60", code: "MY", flag: "🇲🇾" },
  { name: "Maldives", dial_code: "+960", code: "MV", flag: "🇲🇻" },
  { name: "Mali", dial_code: "+223", code: "ML", flag: "🇲🇱" },
  { name: "Malta", dial_code: "+356", code: "MT", flag: "🇲🇹" },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
    flag: "🇲🇭",
  },
  { name: "Martinique", dial_code: "+596", code: "MQ", flag: "🇲🇶" },
  { name: "Mauritania", dial_code: "+222", code: "MR", flag: "🇲🇷" },
  { name: "Mauritius", dial_code: "+230", code: "MU", flag: "🇲🇺" },
  { name: "Mayotte", dial_code: "+262", code: "YT", flag: "🇾🇹" },
  { name: "Mexico", dial_code: "+52", code: "MX", flag: "🇲🇽" },
  {
    name: "Micronesia, Federated States of Micronesia",
    dial_code: "+691",
    code: "FM",
    flag: "🇫🇲",
  },
  { name: "Moldova", dial_code: "+373", code: "MD", flag: "🇲🇩" },
  { name: "Monaco", dial_code: "+377", code: "MC", flag: "🇲🇨" },
  { name: "Mongolia", dial_code: "+976", code: "MN", flag: "🇲🇳" },
  { name: "Montenegro", dial_code: "+382", code: "ME", flag: "🇲🇪" },
  { name: "Montserrat", dial_code: "+1664", code: "MS", flag: "🇲🇸" },
  { name: "Morocco", dial_code: "+212", code: "MA", flag: "🇲🇦" },
  { name: "Mozambique", dial_code: "+258", code: "MZ", flag: "🇲🇿" },
  { name: "Myanmar", dial_code: "+95", code: "MM", flag: "🇲🇲" },
  { name: "Namibia", dial_code: "+264", code: "NA", flag: "🇳🇦" },
  { name: "Nauru", dial_code: "+674", code: "NR", flag: "🇳🇷" },
  { name: "Nepal", dial_code: "+977", code: "NP", flag: "🇳🇵" },
  { name: "Netherlands", dial_code: "+31", code: "NL", flag: "🇳🇱" },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
    flag: "🇳🇱",
  },
  { name: "New Caledonia", dial_code: "+687", code: "NC", flag: "🇳🇨" },
  { name: "New Zealand", dial_code: "+64", code: "NZ", flag: "🇳🇿" },
  { name: "Nicaragua", dial_code: "+505", code: "NI", flag: "🇳🇮" },
  { name: "Niger", dial_code: "+227", code: "NE", flag: "🇳🇪" },
  { name: "Nigeria", dial_code: "+234", code: "NG", flag: "🇳🇬" },
  { name: "Niue", dial_code: "+683", code: "NU", flag: "🇳🇺" },
  { name: "Norfolk Island", dial_code: "+672", code: "NF", flag: "🇳🇫" },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1670",
    code: "MP",
    flag: "🏳",
  },
  { name: "Norway", dial_code: "+47", code: "NO", flag: "🇳🇴" },
  { name: "Oman", dial_code: "+968", code: "OM", flag: "🇴🇲" },
  { name: "Pakistan", dial_code: "+92", code: "PK", flag: "🇵🇰" },
  { name: "Palau", dial_code: "+680", code: "PW", flag: "🇵🇼" },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
    flag: "🇵🇸",
  },
  { name: "Panama", dial_code: "+507", code: "PA", flag: "🇵🇦" },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
    flag: "🇵🇬",
  },
  { name: "Paraguay", dial_code: "+595", code: "PY", flag: "🇵🇾" },
  { name: "Peru", dial_code: "+51", code: "PE", flag: "🇵🇪" },
  { name: "Philippines", dial_code: "+63", code: "PH", flag: "🇵🇭" },
  { name: "Pitcairn", dial_code: "+64", code: "PN", flag: "🇵🇳" },
  { name: "Poland", dial_code: "+48", code: "PL", flag: "🇵🇱" },
  { name: "Portugal", dial_code: "+351", code: "PT", flag: "🇵🇹" },
  { name: "Puerto Rico", dial_code: "+1939", code: "PR", flag: "🇵🇷" },
  { name: "Qatar", dial_code: "+974", code: "QA", flag: "🇶🇦" },
  { name: "Romania", dial_code: "+40", code: "RO", flag: "🇷🇴" },
  { name: "Russia", dial_code: "+7", code: "RU", flag: "🇷🇺" },
  { name: "Rwanda", dial_code: "+250", code: "RW", flag: "🇷🇼" },
  { name: "Reunion", dial_code: "+262", code: "RE", flag: "🇫🇷" },
  {
    name: "Saint Barthelemy",
    dial_code: "+590",
    code: "BL",
    flag: "🇧🇱",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
    flag: "🇸🇭",
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1869",
    code: "KN",
    flag: "🇰🇳",
  },
  { name: "Saint Lucia", dial_code: "+1758", code: "LC", flag: "🇱🇨" },
  { name: "Saint Martin", dial_code: "+590", code: "MF", flag: "🏳" },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
    flag: "🇵🇲",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1784",
    code: "VC",
    flag: "🇻🇨",
  },
  { name: "Samoa", dial_code: "+685", code: "WS", flag: "🇼🇸" },
  { name: "San Marino", dial_code: "+378", code: "SM", flag: "🇸🇲" },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
    flag: "🇸🇹",
  },
  { name: "Saudi Arabia", dial_code: "+966", code: "SA", flag: "🇸🇦" },
  { name: "Senegal", dial_code: "+221", code: "SN", flag: "🇸🇳" },
  { name: "Serbia", dial_code: "+381", code: "RS", flag: "🇷🇸" },
  { name: "Seychelles", dial_code: "+248", code: "SC", flag: "🇸🇨" },
  { name: "Sierra Leone", dial_code: "+232", code: "SL", flag: "🇸🇱" },
  { name: "Singapore", dial_code: "+65", code: "SG", flag: "🇸🇬" },
  { name: "Slovakia", dial_code: "+421", code: "SK", flag: "🇸🇰" },
  { name: "Slovenia", dial_code: "+386", code: "SI", flag: "🇸🇮" },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
    flag: "🇸🇧",
  },
  { name: "Somalia", dial_code: "+252", code: "SO", flag: "🇸🇴" },
  { name: "South Africa", dial_code: "+27", code: "ZA", flag: "🇿🇦" },
  { name: "South Sudan", dial_code: "+211", code: "SS", flag: "🇸🇸" },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
    flag: "🇬🇸",
  },
  { name: "Spain", dial_code: "+34", code: "ES", flag: "🇪🇸" },
  { name: "Sri Lanka", dial_code: "+94", code: "LK", flag: "🇱🇰" },
  { name: "Sudan", dial_code: "+249", code: "SD", flag: "🇸🇩" },
  { name: "Suriname", dial_code: "+597", code: "SR", flag: "🇸🇷" },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
    flag: "🇩🇰",
  },
  { name: "Swaziland", dial_code: "+268", code: "SZ", flag: "🇸🇿" },
  { name: "Sweden", dial_code: "+46", code: "SE", flag: "🇸🇪" },
  { name: "Switzerland", dial_code: "+41", code: "CH", flag: "🇨🇭" },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
    flag: "🇸🇾",
  },
  { name: "Taiwan", dial_code: "+886", code: "TW", flag: "🇹🇼" },
  { name: "Tajikistan", dial_code: "+992", code: "TJ", flag: "🇹🇯" },
  {
    name: "Tanzania, United Republic of Tanzania",
    dial_code: "+255",
    code: "TZ",
    flag: "🇹🇿",
  },
  { name: "Thailand", dial_code: "+66", code: "TH", flag: "🇹🇭" },
  { name: "Timor-Leste", dial_code: "+670", code: "TL", flag: "🇹🇱" },
  { name: "Togo", dial_code: "+228", code: "TG", flag: "🇹🇬" },
  { name: "Tokelau", dial_code: "+690", code: "TK", flag: "🇹🇰" },
  { name: "Tonga", dial_code: "+676", code: "TO", flag: "🇹🇴" },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1868",
    code: "TT",
    flag: "🇹🇹",
  },
  { name: "Tunisia", dial_code: "+216", code: "TN", flag: "🇹🇳" },
  { name: "Turkey", dial_code: "+90", code: "TR", flag: "🇹🇷" },
  { name: "Turkmenistan", dial_code: "+993", code: "TM", flag: "🇹🇲" },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1649",
    code: "TC",
    flag: "🇹🇨",
  },
  { name: "Tuvalu", dial_code: "+688", code: "TV", flag: "🇹🇻" },
  { name: "Uganda", dial_code: "+256", code: "UG", flag: "🇺🇬" },
  { name: "Ukraine", dial_code: "+380", code: "UA", flag: "🇺🇦" },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
    flag: "🇦🇪",
  },
  { name: "United Kingdom", dial_code: "+44", code: "GB", flag: "🇬🇧" },
  { name: "United States", dial_code: "+1", code: "US", flag: "🇺🇸" },
  { name: "Uruguay", dial_code: "+598", code: "UY", flag: "🇺🇾" },
  { name: "Uzbekistan", dial_code: "+998", code: "UZ", flag: "🇺🇿" },
  { name: "Vanuatu", dial_code: "+678", code: "VU", flag: "🇻🇺" },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dial_code: "+58",
    code: "VE",
    flag: "🇻🇪",
  },
  { name: "Vietnam", dial_code: "+84", code: "VN", flag: "🇻🇳" },
  {
    name: "Virgin Islands, British",
    dial_code: "+1284",
    code: "VG",
    flag: "🇻🇬",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1340",
    code: "VI",
    flag: "🇻🇮",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
    flag: "🇼🇫",
  },
  { name: "Yemen", dial_code: "+967", code: "YE", flag: "🇾🇪" },
  { name: "Zambia", dial_code: "+260", code: "ZM", flag: "🇿🇲" },
  { name: "Zimbabwe", dial_code: "+263", code: "ZW", flag: "🇿🇼" },
];


export const initialContextMenu = {
  show: false,
  x: 0,
  y: 0
}

export const updateDuplicateValues = (arr: any, keys: Array<string>) => {
  const valueCounts: any = {};
  for (const obj of arr) {
    for (const key of keys) {
      const value = obj[key];
      if (valueCounts[key] === undefined) {
        valueCounts[key] = {};
      }

      if (valueCounts[key][value] === undefined) {
        valueCounts[key][value] = 1;
      } else {
        valueCounts[key][value]++;
        obj[key] = `${value}_${valueCounts[key][value]}`;
      }
    }
  }

  return arr;
}

export const addValueAndMaintainLength = (array: [any], value: any) => {
  array.push(value); // Add the new value to the end of the array

  if (array.length > 10) {
    array.shift(); // Remove the first value if array length exceeds 10
  }
  return array
}

export const responseJsonData = {
  statusCode: 200,
  message: "Data fetched successfully",
  data: {
    dropdownData: [
      {
        label: "Option1",
        value: "option1"
      },
      {
        label: "Option2",
        value: "option2"
      }
    ]
  }
};

export const CustomNote = (content: string) => {
  return <div className="custom-note-container"><img src={noteIcon} alt="" /><span dangerouslySetInnerHTML={{ __html: content }} /></div>
}

export const DefaultChoicesNote = () => {
  const isLessThan1160 = useMediaQuery("(max-width:1160px)");
  const isLessThan1650 = useMediaQuery("(max-width:1650px)");

  const containerHeight = React.useMemo(() => {
    if (isLessThan1160) {
      return "100px";
    }

    if (isLessThan1650) {
      return "80px";
    }

    return "60px";
  }, [isLessThan1160, isLessThan1650]);

  return (
    <DefaultChoicesContainer containerHeight={containerHeight}>
      <DefaultChoicesImageContainer>
        <img alt="" src={noteIcon} />
      </DefaultChoicesImageContainer>
      <DefaultChoicesTextContainer>
        Note: You can add default choices so that if API gets failed your
        choices will be populated
      </DefaultChoicesTextContainer>
    </DefaultChoicesContainer>
  );
}

export const ResponseFormatNote = () => {
  return (
    <DefaultChoicesContainer>
      <DefaultChoicesImageContainer>
        <img alt="" src={noteIcon} />
      </DefaultChoicesImageContainer>
      <DefaultChoicesTextContainer>
        Note: The response must be in same format i.e, data.dropdownData. Label is the key which user see in the dropdown and value is the key in which all the other operations are performed such as API calling on selection of option.
      </DefaultChoicesTextContainer>
    </DefaultChoicesContainer>
  );
}

export const conversationalFormsURL = process.env.REACT_APP_FORM_URL

export const waymoreFormsURL = process.env.REACT_APP_WAYMORE_FORMS_URL

export const builderURL = process.env.REACT_APP_BUILDER_URL

export const handleDropdownData = (data: any) => {
  if (data) {
    return data?.map((data: any) => ({ label: data?.name || "", value: data?.name || "", data })) || []
  } else {
    return []
  }
}

export const parseUrl = (url: string) => {
  const searchParams = new URLSearchParams(new URL(url).search);
  return searchParams.get('id');
}

export const createFormPopupJson = [
  {
    'icon': createFormIcon,
    'Header': 'Start from scratch',
    'description': 'Create something visually striking from scratch.'
  },
  {
    'icon': selectFromTemplateIcon,
    'Header': 'Select from template',
    'description': 'Unlock creativity with our pre-made templates, ready for immediate use.'
  },
  {
    'icon': createUsingAIIcon,
    'Header': 'Create with AI',
    'description': 'Accelerate form creation with AI-generated initial drafts, saving you valuable time.'
  }

]

export const DayLightTimezone = [
  { label: "(GMT-11) Pacific/Midway" },
  { label: "(GMT-11) Pacific/Niue" },
  { label: "(GMT-11) Pacific/Pago Pago" },
  { label: "(GMT-10) Pacific/Honolulu" },
  { label: "(GMT-10) Pacific/Rarotonga" },
  { label: "(GMT-10) Pacific/Tahiti" },
  { label: "(GMT-9.5) Pacific/Marquesas" },
  { label: "(GMT-9) America/Adak" },
  { label: "(GMT-9) Pacific/Gambier" },
  { label: "(GMT-8) America/Anchorage" },
  { label: "(GMT-8) America/Juneau" },
  { label: "(GMT-8) America/Metlakatla" },
  { label: "(GMT-8) America/Nome" },
  { label: "(GMT-8) America/Sitka" },
  { label: "(GMT-8) America/Yakutat" },
  { label: "(GMT-8) Pacific/Pitcairn" },
  { label: "(GMT-7) America/Chihuahua" },
  { label: "(GMT-7) America/Creston" },
  { label: "(GMT-7) America/Dawson" },
  { label: "(GMT-7) America/Dawson Creek" },
  { label: "(GMT-7) America/Fort Nelson" },
  { label: "(GMT-7) America/Hermosillo" },
  { label: "(GMT-7) America/Los Angeles" },
  { label: "(GMT-7) America/Mazatlan" },
  { label: "(GMT-7) America/Phoenix" },
  { label: "(GMT-7) America/Tijuana" },
  { label: "(GMT-7) America/Vancouver" },
  { label: "(GMT-7) America/Whitehorse" },
  { label: "(GMT-6) America/Bahia Banderas" },
  { label: "(GMT-6) America/Belize" },
  { label: "(GMT-6) America/Boise" },
  { label: "(GMT-6) America/Cambridge Bay" },
  { label: "(GMT-6) America/Costa Rica" },
  { label: "(GMT-6) America/Denver" },
  { label: "(GMT-6) America/Edmonton" },
  { label: "(GMT-6) America/El Salvador" },
  { label: "(GMT-6) America/Guatemala" },
  { label: "(GMT-6) America/Inuvik" },
  { label: "(GMT-6) America/Managua" },
  { label: "(GMT-6) America/Merida" },
  { label: "(GMT-6) America/Mexico City" },
  { label: "(GMT-6) America/Monterrey" },
  { label: "(GMT-6) America/Ojinaga" },
  { label: "(GMT-6) America/Regina" },
  { label: "(GMT-6) America/Swift Current" },
  { label: "(GMT-6) America/Tegucigalpa" },
  { label: "(GMT-6) America/Yellowknife" },
  { label: "(GMT-6) Pacific/Galapagos" },
  { label: "(GMT-5) America/Atikokan" },
  { label: "(GMT-5) America/Bogota" },
  { label: "(GMT-5) America/Cancun" },
  { label: "(GMT-5) America/Cayman" },
  { label: "(GMT-5) America/Chicago" },
  { label: "(GMT-5) America/Eirunepe" },
  { label: "(GMT-5) America/Guayaquil" },
  { label: "(GMT-5) America/Indiana/Knox" },
  { label: "(GMT-5) America/Indiana/Tell City" },
  { label: "(GMT-5) America/Jamaica" },
  { label: "(GMT-5) America/Lima" },
  { label: "(GMT-5) America/Matamoros" },
  { label: "(GMT-5) America/Menominee" },
  { label: "(GMT-5) America/North Dakota/Beulah" },
  { label: "(GMT-5) America/North Dakota/Center" },
  { label: "(GMT-5) America/North Dakota/New Salem" },
  { label: "(GMT-5) America/Panama" },
  { label: "(GMT-5) America/Rainy River" },
  { label: "(GMT-5) America/Rankin Inlet" },
  { label: "(GMT-5) America/Resolute" },
  { label: "(GMT-5) America/Rio Branco" },
  { label: "(GMT-5) America/Winnipeg" },
  { label: "(GMT-5) Pacific/Easter" },
  { label: "(GMT-4) America/Anguilla" },
  { label: "(GMT-4) America/Antigua" },
  { label: "(GMT-4) America/Aruba" },
  { label: "(GMT-4) America/Asuncion" },
  { label: "(GMT-4) America/Barbados" },
  { label: "(GMT-4) America/Blanc-Sablon" },
  { label: "(GMT-4) America/Boa Vista" },
  { label: "(GMT-4) America/Campo Grande" },
  { label: "(GMT-4) America/Caracas" },
  { label: "(GMT-4) America/Cuiaba" },
  { label: "(GMT-4) America/Curacao" },
  { label: "(GMT-4) America/Detroit" },
  { label: "(GMT-4) America/Dominica" },
  { label: "(GMT-4) America/Grand Turk" },
  { label: "(GMT-4) America/Grenada" },
  { label: "(GMT-4) America/Guadeloupe" },
  { label: "(GMT-4) America/Guyana" },
  { label: "(GMT-4) America/Havana" },
  { label: "(GMT-4) America/Indiana/Indianapolis" },
  { label: "(GMT-4) America/Indiana/Marengo" },
  { label: "(GMT-4) America/Indiana/Petersburg" },
  { label: "(GMT-4) America/Indiana/Vevay" },
  { label: "(GMT-4) America/Indiana/Vincennes" },
  { label: "(GMT-4) America/Indiana/Winamac" },
  { label: "(GMT-4) America/Iqaluit" },
  { label: "(GMT-4) America/Kentucky/Louisville" },
  { label: "(GMT-4) America/Kentucky/Monticello" },
  { label: "(GMT-4) America/Kralendijk" },
  { label: "(GMT-4) America/La Paz" },
  { label: "(GMT-4) America/Lower Princes" },
  { label: "(GMT-4) America/Manaus" },
  { label: "(GMT-4) America/Marigot" },
  { label: "(GMT-4) America/Martinique" },
  { label: "(GMT-4) America/Montserrat" },
  { label: "(GMT-4) America/Nassau" },
  { label: "(GMT-4) America/New York" },
  { label: "(GMT-4) America/Nipigon" },
  { label: "(GMT-4) America/Pangnirtung" },
  { label: "(GMT-4) America/Port of Spain" },
  { label: "(GMT-4) America/Port-au-Prince" },
  { label: "(GMT-4) America/Porto Velho" },
  { label: "(GMT-4) America/Puerto Rico" },
  { label: "(GMT-4) America/Santo Domingo" },
  { label: "(GMT-4) America/St Barthelemy" },
  { label: "(GMT-4) America/St Kitts" },
  { label: "(GMT-4) America/St Lucia" },
  { label: "(GMT-4) America/St Thomas" },
  { label: "(GMT-4) America/St Vincent" },
  { label: "(GMT-4) America/Thunder Bay" },
  { label: "(GMT-4) America/Toronto" },
  { label: "(GMT-4) America/Tortola" },
  { label: "(GMT-3) America/Araguaina" },
  { label: "(GMT-3) America/Argentina/Buenos Aires" },
  { label: "(GMT-3) America/Argentina/Catamarca" },
  { label: "(GMT-3) America/Argentina/Cordoba" },
  { label: "(GMT-3) America/Argentina/Jujuy" },
  { label: "(GMT-3) America/Argentina/La Rioja" },
  { label: "(GMT-3) America/Argentina/Mendoza" },
  { label: "(GMT-3) America/Argentina/Rio Gallegos" },
  { label: "(GMT-3) America/Argentina/Salta" },
  { label: "(GMT-3) America/Argentina/San Juan" },
  { label: "(GMT-3) America/Argentina/San Luis" },
  { label: "(GMT-3) America/Argentina/Tucuman" },
  { label: "(GMT-3) America/Argentina/Ushuaia" },
  { label: "(GMT-3) America/Bahia" },
  { label: "(GMT-3) America/Belem" },
  { label: "(GMT-3) America/Cayenne" },
  { label: "(GMT-3) America/Fortaleza" },
  { label: "(GMT-3) America/Glace Bay" },
  { label: "(GMT-3) America/Goose Bay" },
  { label: "(GMT-3) America/Halifax" },
  { label: "(GMT-3) America/Maceio" },
  { label: "(GMT-3) America/Moncton" },
  { label: "(GMT-3) America/Montevideo" },
  { label: "(GMT-3) America/Paramaribo" },
  { label: "(GMT-3) America/Punta Arenas" },
  { label: "(GMT-3) America/Recife" },
  { label: "(GMT-3) America/Santarem" },
  { label: "(GMT-3) America/Santiago" },
  { label: "(GMT-3) America/Sao Paulo" },
  { label: "(GMT-3) America/Thule" },
  { label: "(GMT-3) Antarctica/Palmer" },
  { label: "(GMT-3) Antarctica/Rothera" },
  { label: "(GMT-3) Atlantic/Bermuda" },
  { label: "(GMT-3) Atlantic/Stanley" },
  { label: "(GMT-2.5) America/St Johns" },
  { label: "(GMT-2) America/Miquelon" },
  { label: "(GMT-2) America/Noronha" },
  { label: "(GMT-2) America/Nuuk" },
  { label: "(GMT-2) Atlantic/South Georgia" },
  { label: "(GMT-1) Atlantic/Cape Verde" },
  { label: "(GMT+0) Africa/Abidjan" },
  { label: "(GMT+0) Africa/Accra" },
  { label: "(GMT+0) Africa/Bamako" },
  { label: "(GMT+0) Africa/Banjul" },
  { label: "(GMT+0) Africa/Bissau" },
  { label: "(GMT+0) Africa/Conakry" },
  { label: "(GMT+0) Africa/Dakar" },
  { label: "(GMT+0) Africa/Freetown" },
  { label: "(GMT+0) Africa/Lome" },
  { label: "(GMT+0) Africa/Monrovia" },
  { label: "(GMT+0) Africa/Nouakchott" },
  { label: "(GMT+0) Africa/Ouagadougou" },
  { label: "(GMT+0) Africa/Sao Tome" },
  { label: "(GMT+0) America/Danmarkshavn" },
  { label: "(GMT+0) America/Scoresbysund" },
  { label: "(GMT+0) Atlantic/Azores" },
  { label: "(GMT+0) Atlantic/Reykjavik" },
  { label: "(GMT+0) Atlantic/St Helena" },
  { label: "(GMT+1) Africa/Algiers" },
  { label: "(GMT+1) Africa/Bangui" },
  { label: "(GMT+1) Africa/Brazzaville" },
  { label: "(GMT+1) Africa/Casablanca" },
  { label: "(GMT+1) Africa/Douala" },
  { label: "(GMT+1) Africa/El Aaiun" },
  { label: "(GMT+1) Africa/Kinshasa" },
  { label: "(GMT+1) Africa/Lagos" },
  { label: "(GMT+1) Africa/Libreville" },
  { label: "(GMT+1) Africa/Luanda" },
  { label: "(GMT+1) Africa/Malabo" },
  { label: "(GMT+1) Africa/Ndjamena" },
  { label: "(GMT+1) Africa/Niamey" },
  { label: "(GMT+1) Africa/Porto-Novo" },
  { label: "(GMT+1) Africa/Tunis" },
  { label: "(GMT+1) Atlantic/Canary" },
  { label: "(GMT+1) Atlantic/Faroe" },
  { label: "(GMT+1) Atlantic/Madeira" },
  { label: "(GMT+1) Europe/Dublin" },
  { label: "(GMT+1) Europe/Guernsey" },
  { label: "(GMT+1) Europe/Isle of Man" },
  { label: "(GMT+1) Europe/Jersey" },
  { label: "(GMT+1) Europe/Lisbon" },
  { label: "(GMT+1) Europe/London" },
  { label: "(GMT+2) Africa/Blantyre" },
  { label: "(GMT+2) Africa/Bujumbura" },
  { label: "(GMT+2) Africa/Cairo" },
  { label: "(GMT+2) Africa/Ceuta" },
  { label: "(GMT+2) Africa/Gaborone" },
  { label: "(GMT+2) Africa/Harare" },
  { label: "(GMT+2) Africa/Johannesburg" },
  { label: "(GMT+2) Africa/Khartoum" },
  { label: "(GMT+2) Africa/Kigali" },
  { label: "(GMT+2) Africa/Lubumbashi" },
  { label: "(GMT+2) Africa/Lusaka" },
  { label: "(GMT+2) Africa/Maputo" },
  { label: "(GMT+2) Africa/Maseru" },
  { label: "(GMT+2) Africa/Mbabane" },
  { label: "(GMT+2) Africa/Tripoli" },
  { label: "(GMT+2) Africa/Windhoek" },
  { label: "(GMT+2) Antarctica/Troll" },
  { label: "(GMT+2) Arctic/Longyearbyen" },
  { label: "(GMT+2) Europe/Amsterdam" },
  { label: "(GMT+2) Europe/Andorra" },
  { label: "(GMT+2) Europe/Belgrade" },
  { label: "(GMT+2) Europe/Berlin" },
  { label: "(GMT+2) Europe/Bratislava" },
  { label: "(GMT+2) Europe/Brussels" },
  { label: "(GMT+2) Europe/Budapest" },
  { label: "(GMT+2) Europe/Busingen" },
  { label: "(GMT+2) Europe/Copenhagen" },
  { label: "(GMT+2) Europe/Gibraltar" },
  { label: "(GMT+2) Europe/Kaliningrad" },
  { label: "(GMT+2) Europe/Ljubljana" },
  { label: "(GMT+2) Europe/Luxembourg" },
  { label: "(GMT+2) Europe/Madrid" },
  { label: "(GMT+2) Europe/Malta" },
  { label: "(GMT+2) Europe/Monaco" },
  { label: "(GMT+2) Europe/Oslo" },
  { label: "(GMT+2) Europe/Paris" },
  { label: "(GMT+2) Europe/Podgorica" },
  { label: "(GMT+2) Europe/Prague" },
  { label: "(GMT+2) Europe/Rome" },
  { label: "(GMT+2) Europe/San Marino" },
  { label: "(GMT+2) Europe/Sarajevo" },
  { label: "(GMT+2) Europe/Skopje" },
  { label: "(GMT+2) Europe/Stockholm" },
  { label: "(GMT+2) Europe/Tirane" },
  { label: "(GMT+2) Europe/Vaduz" },
  { label: "(GMT+2) Europe/Vatican" },
  { label: "(GMT+2) Europe/Vienna" },
  { label: "(GMT+2) Europe/Warsaw" },
  { label: "(GMT+2) Europe/Zagreb" },
  { label: "(GMT+2) Europe/Zurich" },
  { label: "(GMT+3) Africa/Addis Ababa" },
  { label: "(GMT+3) Africa/Asmara" },
  { label: "(GMT+3) Africa/Dar es Salaam" },
  { label: "(GMT+3) Africa/Djibouti" },
  { label: "(GMT+3) Africa/Juba" },
  { label: "(GMT+3) Africa/Kampala" },
  { label: "(GMT+3) Africa/Mogadishu" },
  { label: "(GMT+3) Africa/Nairobi" },
  { label: "(GMT+3) Antarctica/Syowa" },
  { label: "(GMT+3) Asia/Aden" },
  { label: "(GMT+3) Asia/Amman" },
  { label: "(GMT+3) Asia/Baghdad" },
  { label: "(GMT+3) Asia/Bahrain" },
  { label: "(GMT+3) Asia/Beirut" },
  { label: "(GMT+3) Asia/Damascus" },
  { label: "(GMT+3) Asia/Famagusta" },
  { label: "(GMT+3) Asia/Gaza" },
  { label: "(GMT+3) Asia/Hebron" },
  { label: "(GMT+3) Asia/Jerusalem" },
  { label: "(GMT+3) Asia/Kuwait" },
  { label: "(GMT+3) Asia/Nicosia" },
  { label: "(GMT+3) Asia/Qatar" },
  { label: "(GMT+3) Asia/Riyadh" },
  { label: "(GMT+3) Europe/Athens" },
  { label: "(GMT+3) Europe/Bucharest" },
  { label: "(GMT+3) Europe/Chisinau" },
  { label: "(GMT+3) Europe/Helsinki" },
  { label: "(GMT+3) Europe/Istanbul" },
  { label: "(GMT+3) Europe/Kirov" },
  { label: "(GMT+3) Europe/Kyiv" },
  { label: "(GMT+3) Europe/Mariehamn" },
  { label: "(GMT+3) Europe/Minsk" },
  { label: "(GMT+3) Europe/Moscow" },
  { label: "(GMT+3) Europe/Riga" },
  { label: "(GMT+3) Europe/Simferopol" },
  { label: "(GMT+3) Europe/Sofia" },
  { label: "(GMT+3) Europe/Tallinn" },
  { label: "(GMT+3) Europe/Uzhgorod" },
  { label: "(GMT+3) Europe/Vilnius" },
  { label: "(GMT+3) Europe/Zaporozhye" },
  { label: "(GMT+3) Indian/Antananarivo" },
  { label: "(GMT+3) Indian/Comoro" },
  { label: "(GMT+3) Indian/Mayotte" },
  { label: "(GMT+4) Asia/Baku" },
  { label: "(GMT+4) Asia/Dubai" },
  { label: "(GMT+4) Asia/Muscat" },
  { label: "(GMT+4) Asia/Tbilisi" },
  { label: "(GMT+4) Asia/Yerevan" },
  { label: "(GMT+4) Europe/Astrakhan" },
  { label: "(GMT+4) Europe/Samara" },
  { label: "(GMT+4) Europe/Saratov" },
  { label: "(GMT+4) Europe/Ulyanovsk" },
  { label: "(GMT+4) Europe/Volgograd" },
  { label: "(GMT+4) Indian/Mahe" },
  { label: "(GMT+4) Indian/Mauritius" },
  { label: "(GMT+4) Indian/Reunion" },
  { label: "(GMT+4.5) Asia/Kabul" },
  { label: "(GMT+4.5) Asia/Tehran" },
  { label: "(GMT+5) Antarctica/Mawson" },
  { label: "(GMT+5) Asia/Aqtau" },
  { label: "(GMT+5) Asia/Aqtobe" },
  { label: "(GMT+5) Asia/Ashgabat" },
  { label: "(GMT+5) Asia/Atyrau" },
  { label: "(GMT+5) Asia/Dushanbe" },
  { label: "(GMT+5) Asia/Karachi" },
  { label: "(GMT+5) Asia/Oral" },
  { label: "(GMT+5) Asia/Qyzylorda" },
  { label: "(GMT+5) Asia/Samarkand" },
  { label: "(GMT+5) Asia/Tashkent" },
  { label: "(GMT+5) Asia/Yekaterinburg" },
  { label: "(GMT+5) Indian/Kerguelen" },
  { label: "(GMT+5) Indian/Maldives" },
  { label: "(GMT+5.5) Asia/Colombo" },
  { label: "(GMT+5.5) Asia/Kolkata" },
  { label: "(GMT+5.75) Asia/Kathmandu" },
  { label: "(GMT+6) Antarctica/Vostok" },
  { label: "(GMT+6) Asia/Almaty" },
  { label: "(GMT+6) Asia/Bishkek" },
  { label: "(GMT+6) Asia/Dhaka" },
  { label: "(GMT+6) Asia/Omsk" },
  { label: "(GMT+6) Asia/Qostanay" },
  { label: "(GMT+6) Asia/Thimphu" },
  { label: "(GMT+6) Asia/Urumqi" },
  { label: "(GMT+6) Indian/Chagos" },
  { label: "(GMT+6.5) Asia/Yangon" },
  { label: "(GMT+6.5) Indian/Cocos" },
  { label: "(GMT+7) Antarctica/Davis" },
  { label: "(GMT+7) Asia/Bangkok" },
  { label: "(GMT+7) Asia/Barnaul" },
  { label: "(GMT+7) Asia/Ho Chi Minh" },
  { label: "(GMT+7) Asia/Hovd" },
  { label: "(GMT+7) Asia/Jakarta" },
  { label: "(GMT+7) Asia/Krasnoyarsk" },
  { label: "(GMT+7) Asia/Novokuznetsk" },
  { label: "(GMT+7) Asia/Novosibirsk" },
  { label: "(GMT+7) Asia/Phnom Penh" },
  { label: "(GMT+7) Asia/Pontianak" },
  { label: "(GMT+7) Asia/Tomsk" },
  { label: "(GMT+7) Asia/Vientiane" },
  { label: "(GMT+7) Indian/Christmas" },
  { label: "(GMT+8) Antarctica/Casey" },
  { label: "(GMT+8) Asia/Brunei" },
  { label: "(GMT+8) Asia/Choibalsan" },
  { label: "(GMT+8) Asia/Hong Kong" },
  { label: "(GMT+8) Asia/Irkutsk" },
  { label: "(GMT+8) Asia/Kuala Lumpur" },
  { label: "(GMT+8) Asia/Kuching" },
  { label: "(GMT+8) Asia/Macau" },
  { label: "(GMT+8) Asia/Makassar" },
  { label: "(GMT+8) Asia/Manila" },
  { label: "(GMT+8) Asia/Shanghai" },
  { label: "(GMT+8) Asia/Singapore" },
  { label: "(GMT+8) Asia/Taipei" },
  { label: "(GMT+8) Asia/Ulaanbaatar" },
  { label: "(GMT+8) Australia/Perth" },
  { label: "(GMT+8.75) Australia/Eucla" },
  { label: "(GMT+9) Asia/Chita" },
  { label: "(GMT+9) Asia/Dili" },
  { label: "(GMT+9) Asia/Jayapura" },
  { label: "(GMT+9) Asia/Khandyga" },
  { label: "(GMT+9) Asia/Pyongyang" },
  { label: "(GMT+9) Asia/Seoul" },
  { label: "(GMT+9) Asia/Tokyo" },
  { label: "(GMT+9) Asia/Yakutsk" },
  { label: "(GMT+9) Pacific/Palau" },
  { label: "(GMT+9.5) Australia/Darwin" },
  { label: "(GMT+10) Antarctica/DumontDUrville" },
  { label: "(GMT+10) Asia/Ust-Nera" },
  { label: "(GMT+10) Asia/Vladivostok" },
  { label: "(GMT+10) Australia/Brisbane" },
  { label: "(GMT+10) Australia/Lindeman" },
  { label: "(GMT+10) Pacific/Chuuk" },
  { label: "(GMT+10) Pacific/Guam" },
  { label: "(GMT+10) Pacific/Port Moresby" },
  { label: "(GMT+10) Pacific/Saipan" },
  { label: "(GMT+10.5) Australia/Adelaide" },
  { label: "(GMT+10.5) Australia/Broken Hill" },
  { label: "(GMT+11) Antarctica/Macquarie" },
  { label: "(GMT+11) Asia/Magadan" },
  { label: "(GMT+11) Asia/Sakhalin" },
  { label: "(GMT+11) Asia/Srednekolymsk" },
  { label: "(GMT+11) Australia/Hobart" },
  { label: "(GMT+11) Australia/Lord Howe" },
  { label: "(GMT+11) Australia/Melbourne" },
  { label: "(GMT+11) Australia/Sydney" },
  { label: "(GMT+11) Pacific/Bougainville" },
  { label: "(GMT+11) Pacific/Efate" },
  { label: "(GMT+11) Pacific/Guadalcanal" },
  { label: "(GMT+11) Pacific/Kosrae" },
  { label: "(GMT+11) Pacific/Norfolk" },
  { label: "(GMT+11) Pacific/Noumea" },
  { label: "(GMT+11) Pacific/Pohnpei" },
  { label: "(GMT+12) Asia/Anadyr" },
  { label: "(GMT+12) Asia/Kamchatka" },
  { label: "(GMT+12) Pacific/Fiji" },
  { label: "(GMT+12) Pacific/Funafuti" },
  { label: "(GMT+12) Pacific/Kwajalein" },
  { label: "(GMT+12) Pacific/Majuro" },
  { label: "(GMT+12) Pacific/Nauru" },
  { label: "(GMT+12) Pacific/Tarawa" },
  { label: "(GMT+12) Pacific/Wake" },
  { label: "(GMT+12) Pacific/Wallis" },
  { label: "(GMT+13) Antarctica/McMurdo" },
  { label: "(GMT+13) Pacific/Auckland" },
  { label: "(GMT+13) Pacific/Fakaofo" },
  { label: "(GMT+13) Pacific/Kanton" },
  { label: "(GMT+13) Pacific/Tongatapu" },
  { label: "(GMT+13.75) Pacific/Chatham" },
  { label: "(GMT+14) Pacific/Apia" },
  { label: "(GMT+14) Pacific/Kiritimati" }
]

export const StandardTimeZone = [
  { label: "(GMT-11) Pacific/Midway" },
  { label: "(GMT-11) Pacific/Niue" },
  { label: "(GMT-11) Pacific/Pago Pago" },
  { label: "(GMT-10) America/Adak" },
  { label: "(GMT-10) Pacific/Honolulu" },
  { label: "(GMT-10) Pacific/Rarotonga" },
  { label: "(GMT-10) Pacific/Tahiti" },
  { label: "(GMT-9.5) Pacific/Marquesas" },
  { label: "(GMT-9) America/Anchorage" },
  { label: "(GMT-9) America/Juneau" },
  { label: "(GMT-9) America/Metlakatla" },
  { label: "(GMT-9) America/Nome" },
  { label: "(GMT-9) America/Sitka" },
  { label: "(GMT-9) America/Yakutat" },
  { label: "(GMT-9) Pacific/Gambier" },
  { label: "(GMT-8) America/Dawson" },
  { label: "(GMT-8) America/Los Angeles" },
  { label: "(GMT-8) America/Tijuana" },
  { label: "(GMT-8) America/Vancouver" },
  { label: "(GMT-8) America/Whitehorse" },
  { label: "(GMT-8) Pacific/Pitcairn" },
  { label: "(GMT-7) America/Boise" },
  { label: "(GMT-7) America/Cambridge Bay" },
  { label: "(GMT-7) America/Chihuahua" },
  { label: "(GMT-7) America/Creston" },
  { label: "(GMT-7) America/Dawson Creek" },
  { label: "(GMT-7) America/Denver" },
  { label: "(GMT-7) America/Edmonton" },
  { label: "(GMT-7) America/Fort Nelson" },
  { label: "(GMT-7) America/Hermosillo" },
  { label: "(GMT-7) America/Inuvik" },
  { label: "(GMT-7) America/Mazatlan" },
  { label: "(GMT-7) America/Ojinaga" },
  { label: "(GMT-7) America/Phoenix" },
  { label: "(GMT-7) America/Yellowknife" },
  { label: "(GMT-6) America/Bahia Banderas" },
  { label: "(GMT-6) America/Belize" },
  { label: "(GMT-6) America/Chicago" },
  { label: "(GMT-6) America/Costa Rica" },
  { label: "(GMT-6) America/El Salvador" },
  { label: "(GMT-6) America/Guatemala" },
  { label: "(GMT-6) America/Indiana/Knox" },
  { label: "(GMT-6) America/Indiana/Tell City" },
  { label: "(GMT-6) America/Managua" },
  { label: "(GMT-6) America/Matamoros" },
  { label: "(GMT-6) America/Menominee" },
  { label: "(GMT-6) America/Merida" },
  { label: "(GMT-6) America/Mexico City" },
  { label: "(GMT-6) America/Monterrey" },
  { label: "(GMT-6) America/North Dakota/Beulah" },
  { label: "(GMT-6) America/North Dakota/Center" },
  { label: "(GMT-6) America/North Dakota/New Salem" },
  { label: "(GMT-6) America/Rainy River" },
  { label: "(GMT-6) America/Rankin Inlet" },
  { label: "(GMT-6) America/Regina" },
  { label: "(GMT-6) America/Resolute" },
  { label: "(GMT-6) America/Swift Current" },
  { label: "(GMT-6) America/Tegucigalpa" },
  { label: "(GMT-6) America/Winnipeg" },
  { label: "(GMT-6) Pacific/Galapagos" },
  { label: "(GMT-5) America/Atikokan" },
  { label: "(GMT-5) America/Bogota" },
  { label: "(GMT-5) America/Cancun" },
  { label: "(GMT-5) America/Cayman" },
  { label: "(GMT-5) America/Detroit" },
  { label: "(GMT-5) America/Eirunepe" },
  { label: "(GMT-5) America/Grand Turk" },
  { label: "(GMT-5) America/Guayaquil" },
  { label: "(GMT-5) America/Havana" },
  { label: "(GMT-5) America/Indiana/Indianapolis" },
  { label: "(GMT-5) America/Indiana/Marengo" },
  { label: "(GMT-5) America/Indiana/Petersburg" },
  { label: "(GMT-5) America/Indiana/Vevay" },
  { label: "(GMT-5) America/Indiana/Vincennes" },
  { label: "(GMT-5) America/Indiana/Winamac" },
  { label: "(GMT-5) America/Iqaluit" },
  { label: "(GMT-5) America/Jamaica" },
  { label: "(GMT-5) America/Kentucky/Louisville" },
  { label: "(GMT-5) America/Kentucky/Monticello" },
  { label: "(GMT-5) America/Lima" },
  { label: "(GMT-5) America/Nassau" },
  { label: "(GMT-5) America/New York" },
  { label: "(GMT-5) America/Nipigon" },
  { label: "(GMT-5) America/Panama" },
  { label: "(GMT-5) America/Pangnirtung" },
  { label: "(GMT-5) America/Port-au-Prince" },
  { label: "(GMT-5) America/Rio Branco" },
  { label: "(GMT-5) America/Thunder Bay" },
  { label: "(GMT-5) America/Toronto" },
  { label: "(GMT-5) Pacific/Easter" },
  { label: "(GMT-4) America/Anguilla" },
  { label: "(GMT-4) America/Antigua" },
  { label: "(GMT-4) America/Aruba" },
  { label: "(GMT-4) America/Barbados" },
  { label: "(GMT-4) America/Blanc-Sablon" },
  { label: "(GMT-4) America/Boa Vista" },
  { label: "(GMT-4) America/Campo Grande" },
  { label: "(GMT-4) America/Caracas" },
  { label: "(GMT-4) America/Cuiaba" },
  { label: "(GMT-4) America/Curacao" },
  { label: "(GMT-4) America/Dominica" },
  { label: "(GMT-4) America/Glace Bay" },
  { label: "(GMT-4) America/Goose Bay" },
  { label: "(GMT-4) America/Grenada" },
  { label: "(GMT-4) America/Guadeloupe" },
  { label: "(GMT-4) America/Guyana" },
  { label: "(GMT-4) America/Halifax" },
  { label: "(GMT-4) America/Kralendijk" },
  { label: "(GMT-4) America/La Paz" },
  { label: "(GMT-4) America/Lower Princes" },
  { label: "(GMT-4) America/Manaus" },
  { label: "(GMT-4) America/Marigot" },
  { label: "(GMT-4) America/Martinique" },
  { label: "(GMT-4) America/Moncton" },
  { label: "(GMT-4) America/Montserrat" },
  { label: "(GMT-4) America/Port of Spain" },
  { label: "(GMT-4) America/Porto Velho" },
  { label: "(GMT-4) America/Puerto Rico" },
  { label: "(GMT-4) America/Santo Domingo" },
  { label: "(GMT-4) America/St Barthelemy" },
  { label: "(GMT-4) America/St Kitts" },
  { label: "(GMT-4) America/St Lucia" },
  { label: "(GMT-4) America/St Thomas" },
  { label: "(GMT-4) America/St Vincent" },
  { label: "(GMT-4) America/Thule" },
  { label: "(GMT-4) America/Tortola" },
  { label: "(GMT-4) Atlantic/Bermuda" },
  { label: "(GMT-3.5) America/St Johns" },
  { label: "(GMT-3) America/Araguaina" },
  { label: "(GMT-3) America/Argentina/Buenos Aires" },
  { label: "(GMT-3) America/Argentina/Catamarca" },
  { label: "(GMT-3) America/Argentina/Cordoba" },
  { label: "(GMT-3) America/Argentina/Jujuy" },
  { label: "(GMT-3) America/Argentina/La Rioja" },
  { label: "(GMT-3) America/Argentina/Mendoza" },
  { label: "(GMT-3) America/Argentina/Rio Gallegos" },
  { label: "(GMT-3) America/Argentina/Salta" },
  { label: "(GMT-3) America/Argentina/San Juan" },
  { label: "(GMT-3) America/Argentina/San Luis" },
  { label: "(GMT-3) America/Argentina/Tucuman" },
  { label: "(GMT-3) America/Argentina/Ushuaia" },
  { label: "(GMT-3) America/Asuncion" },
  { label: "(GMT-3) America/Bahia" },
  { label: "(GMT-3) America/Belem" },
  { label: "(GMT-3) America/Cayenne" },
  { label: "(GMT-3) America/Fortaleza" },
  { label: "(GMT-3) America/Maceio" },
  { label: "(GMT-3) America/Miquelon" },
  { label: "(GMT-3) America/Montevideo" },
  { label: "(GMT-3) America/Nuuk" },
  { label: "(GMT-3) America/Paramaribo" },
  { label: "(GMT-3) America/Punta Arenas" },
  { label: "(GMT-3) America/Recife" },
  { label: "(GMT-3) America/Santarem" },
  { label: "(GMT-3) America/Santiago" },
  { label: "(GMT-3) America/Sao Paulo" },
  { label: "(GMT-3) Antarctica/Palmer" },
  { label: "(GMT-3) Antarctica/Rothera" },
  { label: "(GMT-3) Atlantic/Stanley" },
  { label: "(GMT-2) America/Noronha" },
  { label: "(GMT-2) Atlantic/South Georgia" },
  { label: "(GMT-1) America/Scoresbysund" },
  { label: "(GMT-1) Atlantic/Azores" },
  { label: "(GMT-1) Atlantic/Cape Verde" },
  { label: "(GMT+0) Africa/Abidjan" },
  { label: "(GMT+0) Africa/Accra" },
  { label: "(GMT+0) Africa/Bamako" },
  { label: "(GMT+0) Africa/Banjul" },
  { label: "(GMT+0) Africa/Bissau" },
  { label: "(GMT+0) Africa/Conakry" },
  { label: "(GMT+0) Africa/Dakar" },
  { label: "(GMT+0) Africa/Freetown" },
  { label: "(GMT+0) Africa/Lome" },
  { label: "(GMT+0) Africa/Monrovia" },
  { label: "(GMT+0) Africa/Nouakchott" },
  { label: "(GMT+0) Africa/Ouagadougou" },
  { label: "(GMT+0) Africa/Sao Tome" },
  { label: "(GMT+0) America/Danmarkshavn" },
  { label: "(GMT+0) Antarctica/Troll" },
  { label: "(GMT+0) Atlantic/Canary" },
  { label: "(GMT+0) Atlantic/Faroe" },
  { label: "(GMT+0) Atlantic/Madeira" },
  { label: "(GMT+0) Atlantic/Reykjavik" },
  { label: "(GMT+0) Atlantic/St Helena" },
  { label: "(GMT+0) Europe/Dublin" },
  { label: "(GMT+0) Europe/Guernsey" },
  { label: "(GMT+0) Europe/Isle of Man" },
  { label: "(GMT+0) Europe/Jersey" },
  { label: "(GMT+0) Europe/Lisbon" },
  { label: "(GMT+0) Europe/London" },
  { label: "(GMT+1) Africa/Algiers" },
  { label: "(GMT+1) Africa/Bangui" },
  { label: "(GMT+1) Africa/Brazzaville" },
  { label: "(GMT+1) Africa/Casablanca" },
  { label: "(GMT+1) Africa/Ceuta" },
  { label: "(GMT+1) Africa/Douala" },
  { label: "(GMT+1) Africa/El Aaiun" },
  { label: "(GMT+1) Africa/Kinshasa" },
  { label: "(GMT+1) Africa/Lagos" },
  { label: "(GMT+1) Africa/Libreville" },
  { label: "(GMT+1) Africa/Luanda" },
  { label: "(GMT+1) Africa/Malabo" },
  { label: "(GMT+1) Africa/Ndjamena" },
  { label: "(GMT+1) Africa/Niamey" },
  { label: "(GMT+1) Africa/Porto-Novo" },
  { label: "(GMT+1) Africa/Tunis" },
  { label: "(GMT+1) Arctic/Longyearbyen" },
  { label: "(GMT+1) Europe/Amsterdam" },
  { label: "(GMT+1) Europe/Andorra" },
  { label: "(GMT+1) Europe/Belgrade" },
  { label: "(GMT+1) Europe/Berlin" },
  { label: "(GMT+1) Europe/Bratislava" },
  { label: "(GMT+1) Europe/Brussels" },
  { label: "(GMT+1) Europe/Budapest" },
  { label: "(GMT+1) Europe/Busingen" },
  { label: "(GMT+1) Europe/Copenhagen" },
  { label: "(GMT+1) Europe/Gibraltar" },
  { label: "(GMT+1) Europe/Ljubljana" },
  { label: "(GMT+1) Europe/Luxembourg" },
  { label: "(GMT+1) Europe/Madrid" },
  { label: "(GMT+1) Europe/Malta" },
  { label: "(GMT+1) Europe/Monaco" },
  { label: "(GMT+1) Europe/Oslo" },
  { label: "(GMT+1) Europe/Paris" },
  { label: "(GMT+1) Europe/Podgorica" },
  { label: "(GMT+1) Europe/Prague" },
  { label: "(GMT+1) Europe/Rome" },
  { label: "(GMT+1) Europe/San Marino" },
  { label: "(GMT+1) Europe/Sarajevo" },
  { label: "(GMT+1) Europe/Skopje" },
  { label: "(GMT+1) Europe/Stockholm" },
  { label: "(GMT+1) Europe/Tirane" },
  { label: "(GMT+1) Europe/Vaduz" },
  { label: "(GMT+1) Europe/Vatican" },
  { label: "(GMT+1) Europe/Vienna" },
  { label: "(GMT+1) Europe/Warsaw" },
  { label: "(GMT+1) Europe/Zagreb" },
  { label: "(GMT+1) Europe/Zurich" },
  { label: "(GMT+2) Africa/Blantyre" },
  { label: "(GMT+2) Africa/Bujumbura" },
  { label: "(GMT+2) Africa/Cairo" },
  { label: "(GMT+2) Africa/Gaborone" },
  { label: "(GMT+2) Africa/Harare" },
  { label: "(GMT+2) Africa/Johannesburg" },
  { label: "(GMT+2) Africa/Khartoum" },
  { label: "(GMT+2) Africa/Kigali" },
  { label: "(GMT+2) Africa/Lubumbashi" },
  { label: "(GMT+2) Africa/Lusaka" },
  { label: "(GMT+2) Africa/Maputo" },
  { label: "(GMT+2) Africa/Maseru" },
  { label: "(GMT+2) Africa/Mbabane" },
  { label: "(GMT+2) Africa/Tripoli" },
  { label: "(GMT+2) Africa/Windhoek" },
  { label: "(GMT+2) Asia/Amman" },
  { label: "(GMT+2) Asia/Beirut" },
  { label: "(GMT+2) Asia/Damascus" },
  { label: "(GMT+2) Asia/Famagusta" },
  { label: "(GMT+2) Asia/Gaza" },
  { label: "(GMT+2) Asia/Hebron" },
  { label: "(GMT+2) Asia/Jerusalem" },
  { label: "(GMT+2) Asia/Nicosia" },
  { label: "(GMT+2) Europe/Athens" },
  { label: "(GMT+2) Europe/Bucharest" },
  { label: "(GMT+2) Europe/Chisinau" },
  { label: "(GMT+2) Europe/Helsinki" },
  { label: "(GMT+2) Europe/Kaliningrad" },
  { label: "(GMT+2) Europe/Kyiv" },
  { label: "(GMT+2) Europe/Mariehamn" },
  { label: "(GMT+2) Europe/Riga" },
  { label: "(GMT+2) Europe/Sofia" },
  { label: "(GMT+2) Europe/Tallinn" },
  { label: "(GMT+2) Europe/Uzhgorod" },
  { label: "(GMT+2) Europe/Vilnius" },
  { label: "(GMT+2) Europe/Zaporozhye" },
  { label: "(GMT+3) Africa/Addis Ababa" },
  { label: "(GMT+3) Africa/Asmara" },
  { label: "(GMT+3) Africa/Dar es Salaam" },
  { label: "(GMT+3) Africa/Djibouti" },
  { label: "(GMT+3) Africa/Juba" },
  { label: "(GMT+3) Africa/Kampala" },
  { label: "(GMT+3) Africa/Mogadishu" },
  { label: "(GMT+3) Africa/Nairobi" },
  { label: "(GMT+3) Antarctica/Syowa" },
  { label: "(GMT+3) Asia/Aden" },
  { label: "(GMT+3) Asia/Baghdad" },
  { label: "(GMT+3) Asia/Bahrain" },
  { label: "(GMT+3) Asia/Kuwait" },
  { label: "(GMT+3) Asia/Qatar" },
  { label: "(GMT+3) Asia/Riyadh" },
  { label: "(GMT+3) Europe/Istanbul" },
  { label: "(GMT+3) Europe/Kirov" },
  { label: "(GMT+3) Europe/Minsk" },
  { label: "(GMT+3) Europe/Moscow" },
  { label: "(GMT+3) Europe/Simferopol" },
  { label: "(GMT+3) Indian/Antananarivo" },
  { label: "(GMT+3) Indian/Comoro" },
  { label: "(GMT+3) Indian/Mayotte" },
  { label: "(GMT+3.5) Asia/Tehran" },
  { label: "(GMT+4) Asia/Baku" },
  { label: "(GMT+4) Asia/Dubai" },
  { label: "(GMT+4) Asia/Muscat" },
  { label: "(GMT+4) Asia/Tbilisi" },
  { label: "(GMT+4) Asia/Yerevan" },
  { label: "(GMT+4) Europe/Astrakhan" },
  { label: "(GMT+4) Europe/Samara" },
  { label: "(GMT+4) Europe/Saratov" },
  { label: "(GMT+4) Europe/Ulyanovsk" },
  { label: "(GMT+4) Europe/Volgograd" },
  { label: "(GMT+4) Indian/Mahe" },
  { label: "(GMT+4) Indian/Mauritius" },
  { label: "(GMT+4) Indian/Reunion" },
  { label: "(GMT+4.5) Asia/Kabul" },
  { label: "(GMT+5) Antarctica/Mawson" },
  { label: "(GMT+5) Asia/Aqtau" },
  { label: "(GMT+5) Asia/Aqtobe" },
  { label: "(GMT+5) Asia/Ashgabat" },
  { label: "(GMT+5) Asia/Atyrau" },
  { label: "(GMT+5) Asia/Dushanbe" },
  { label: "(GMT+5) Asia/Karachi" },
  { label: "(GMT+5) Asia/Oral" },
  { label: "(GMT+5) Asia/Qyzylorda" },
  { label: "(GMT+5) Asia/Samarkand" },
  { label: "(GMT+5) Asia/Tashkent" },
  { label: "(GMT+5) Asia/Yekaterinburg" },
  { label: "(GMT+5) Indian/Kerguelen" },
  { label: "(GMT+5) Indian/Maldives" },
  { label: "(GMT+5.5) Asia/Colombo" },
  { label: "(GMT+5.5) Asia/Kolkata" },
  { label: "(GMT+5.75) Asia/Kathmandu" },
  { label: "(GMT+6) Antarctica/Vostok" },
  { label: "(GMT+6) Asia/Almaty" },
  { label: "(GMT+6) Asia/Bishkek" },
  { label: "(GMT+6) Asia/Dhaka" },
  { label: "(GMT+6) Asia/Omsk" },
  { label: "(GMT+6) Asia/Qostanay" },
  { label: "(GMT+6) Asia/Thimphu" },
  { label: "(GMT+6) Asia/Urumqi" },
  { label: "(GMT+6) Indian/Chagos" },
  { label: "(GMT+6.5) Asia/Yangon" },
  { label: "(GMT+6.5) Indian/Cocos" },
  { label: "(GMT+7) Antarctica/Davis" },
  { label: "(GMT+7) Asia/Bangkok" },
  { label: "(GMT+7) Asia/Barnaul" },
  { label: "(GMT+7) Asia/Ho Chi Minh" },
  { label: "(GMT+7) Asia/Hovd" },
  { label: "(GMT+7) Asia/Jakarta" },
  { label: "(GMT+7) Asia/Krasnoyarsk" },
  { label: "(GMT+7) Asia/Novokuznetsk" },
  { label: "(GMT+7) Asia/Novosibirsk" },
  { label: "(GMT+7) Asia/Phnom Penh" },
  { label: "(GMT+7) Asia/Pontianak" },
  { label: "(GMT+7) Asia/Tomsk" },
  { label: "(GMT+7) Asia/Vientiane" },
  { label: "(GMT+7) Indian/Christmas" },
  { label: "(GMT+8) Asia/Brunei" },
  { label: "(GMT+8) Asia/Choibalsan" },
  { label: "(GMT+8) Asia/Hong Kong" },
  { label: "(GMT+8) Asia/Irkutsk" },
  { label: "(GMT+8) Asia/Kuala Lumpur" },
  { label: "(GMT+8) Asia/Kuching" },
  { label: "(GMT+8) Asia/Macau" },
  { label: "(GMT+8) Asia/Makassar" },
  { label: "(GMT+8) Asia/Manila" },
  { label: "(GMT+8) Asia/Shanghai" },
  { label: "(GMT+8) Asia/Singapore" },
  { label: "(GMT+8) Asia/Taipei" },
  { label: "(GMT+8) Asia/Ulaanbaatar" },
  { label: "(GMT+8) Australia/Perth" },
  { label: "(GMT+8.75) Australia/Eucla" },
  { label: "(GMT+9) Asia/Chita" },
  { label: "(GMT+9) Asia/Dili" },
  { label: "(GMT+9) Asia/Jayapura" },
  { label: "(GMT+9) Asia/Khandyga" },
  { label: "(GMT+9) Asia/Pyongyang" },
  { label: "(GMT+9) Asia/Seoul" },
  { label: "(GMT+9) Asia/Tokyo" },
  { label: "(GMT+9) Asia/Yakutsk" },
  { label: "(GMT+9) Pacific/Palau" },
  { label: "(GMT+9.5) Australia/Darwin" },
  { label: "(GMT+10) Antarctica/DumontDUrville" },
  { label: "(GMT+10) Asia/Ust-Nera" },
  { label: "(GMT+10) Asia/Vladivostok" },
  { label: "(GMT+10) Australia/Brisbane" },
  { label: "(GMT+10) Australia/Lindeman" },
  { label: "(GMT+10) Pacific/Chuuk" },
  { label: "(GMT+10) Pacific/Guam" },
  { label: "(GMT+10) Pacific/Port Moresby" },
  { label: "(GMT+10) Pacific/Saipan" },
  { label: "(GMT+10.5) Australia/Adelaide" },
  { label: "(GMT+10.5) Australia/Broken Hill" },
  { label: "(GMT+11) Antarctica/Casey" },
  { label: "(GMT+11) Antarctica/Macquarie" },
  { label: "(GMT+11) Asia/Magadan" },
  { label: "(GMT+11) Asia/Sakhalin" },
  { label: "(GMT+11) Asia/Srednekolymsk" },
  { label: "(GMT+11) Australia/Hobart" },
  { label: "(GMT+11) Australia/Lord Howe" },
  { label: "(GMT+11) Australia/Melbourne" },
  { label: "(GMT+11) Australia/Sydney" },
  { label: "(GMT+11) Pacific/Bougainville" },
  { label: "(GMT+11) Pacific/Efate" },
  { label: "(GMT+11) Pacific/Guadalcanal" },
  { label: "(GMT+11) Pacific/Kosrae" },
  { label: "(GMT+11) Pacific/Norfolk" },
  { label: "(GMT+11) Pacific/Noumea" },
  { label: "(GMT+11) Pacific/Pohnpei" },
  { label: "(GMT+12) Asia/Anadyr" },
  { label: "(GMT+12) Asia/Kamchatka" },
  { label: "(GMT+12) Pacific/Fiji" },
  { label: "(GMT+12) Pacific/Funafuti" },
  { label: "(GMT+12) Pacific/Kwajalein" },
  { label: "(GMT+12) Pacific/Majuro" },
  { label: "(GMT+12) Pacific/Nauru" },
  { label: "(GMT+12) Pacific/Tarawa" },
  { label: "(GMT+12) Pacific/Wake" },
  { label: "(GMT+12) Pacific/Wallis" },
  { label: "(GMT+13) Antarctica/McMurdo" },
  { label: "(GMT+13) Pacific/Auckland" },
  { label: "(GMT+13) Pacific/Fakaofo" },
  { label: "(GMT+13) Pacific/Kanton" },
  { label: "(GMT+13) Pacific/Tongatapu" },
  { label: "(GMT+13.75) Pacific/Chatham" },
  { label: "(GMT+14) Pacific/Apia" },
  { label: "(GMT+14) Pacific/Kiritimati" },
]

export const CustomPaper = (props: any) => {
  return (
    <Paper
      style={{ color: "#FFFF", background: "transparent", marginButtom: '10px', borderBottom: '2px dashed #FFFF' }}
      {...props}
    />
  );
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const convertNumberToArray = (min: number, max: number) => {
  return Array.from({ length: max - min + 1 }, (v, k) => k + min);
}

export const getVariables = (title: string) => {
  const regex = /\[@([^\]]+)\]/g;
  const variables = [];
  let match;
  // Use a while loop to find all matches
  while ((match = regex.exec(title)) !== null) {
    variables.push(match[1]);
  }
  return variables;
}

export const copySuccess = { open: true, severity: 'success', message: 'Link copied successfully' }
export const copyFailure = { open: true, severity: 'error', message: 'Error copying link' }


export const isCenteredContant = (thankyouPageContant: string, contant: string) => {

  if (!thankyouPageContant) {
    return false
  }
  if (thankyouPageContant.includes(contant)) {
    return true;
  }
  return false;
}


export const getCookie = (name: string) => {
  const value: string = '; ' + document.cookie;
  const parts = value?.split('; ' + name + '=');

  if (parts?.length === 2) {
    return parts?.pop()?.split(';')?.shift();
  }
}



export const conversationalFormEvents = {
  "dwh": {
    "SourceType": "sourceType",
    "Timestamp": 0,
    "EventName": "transactional_form_submited",
    "EventType": "system"
  },
  "data": {
    "form_name": "string",
    "background_settings": {
      "background_url": "string",
      "submit_page_background_url": "string",
      "background_color": "string"
    },
    "welcome_page_settings": {
      "enabled": false,
      "background_url": "string",
      "text": "string",
      "text_color": "string",
      "button_color": "string"
    },
    "thank_you_page": {
      "html": "string",
      "vertical_center": false,
      "horizontal_center": false
    },
    "conversational_form_settings": {
      "application": "string",
      "department": "string",
      "use_case": "string",
      "watermark": {
        "enabled": false,
        "position": "string"
      }
    },
    "contacts": {
      "save_submissions": false
    },
    "general_settings": {
      "text_color": "string",
      "button_color": "string",
      "button_text_color": "string",
      "loader_color": "string",
      "record_video": "boolean",
      "allow_new_responses": "boolean",
      "display_recorded_video": "boolean",
      "email_submission": "boolean",
      "send_response_to_user": "boolean",
      "send_data_to_endpoint": "boolean",
      "google_analytics": "boolean",
      "gtm": "boolean"
    },

    "event_info": {
      "display_name": "Conversational Form Creation",
      "description": "This event is fired when a user creates a new form",
      "natural_language": "A new form was created with specified settings.",
      "type": "active",
      "source": "waymore.js",
      "cookie_id": "string"
    }
  },

}

export const commonFileTypes = [
  { label: 'Images (All)', value: 'image/*' },
  { label: 'Video (All)', value: 'video/*' },
  { label: 'Audio (All)', value: 'audio/*' },
  { label: 'PDF (.pdf)', value: '.pdf' },
  { label: 'Word (.doc)', value: '.doc' },
  { label: 'Word (.docx)', value: '.docx' },
  { label: 'Excel (.xls)', value: '.xls' },
  { label: 'Excel (.xlsx)', value: '.xlsx' },
  { label: 'PowerPoint (.ppt)', value: '.ppt' },
  { label: 'PowerPoint (.pptx)', value: '.pptx' },
  { label: 'Text (.txt)', value: '.txt' },
  { label: 'CSV (.csv)', value: '.csv' },
  { label: 'ZIP (.zip)', value: '.zip' },
  { label: 'JSON (.json)', value: '.json' },
  { label: 'XML (.xml)', value: '.xml' },
]
